import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Form} from "antd";

import "./style.css";
import "../detail/detail.css";

class FormItem extends PureComponent {

    static propTypes = {
        form: PropTypes.object.isRequired,
        itemType: PropTypes.string.isRequired,
        formKey: PropTypes.string.isRequired,
    }

    static defaultProps = {
        options: {rules: {}},
        form: {},
        formKey: "",
        itemType: "input",
        fieldProps: {},
        setValidatedStatus: false,
        isUpdateInfo: false,
    }

    // 用户自定义函数
    static customFunctions = ['getExtendsField', 'getPositionTypeId', 'positionTypeId', 'getPositionAccount', 'value', 'divisionName', 'setFiledValidateStatus', 'belongDeptId', 'positionId', 'addDangerDisposer', 'delDangerDisposer', 'firstIndex', 'isAuditing', 'formInfoData', 'onlyEdit', 'fieldType', 'fieldTip', 'updateMainDeptName','uploadCount','canEdit','confirmContent','fieldFillRules','isUpdateInfo','labelName','userInfo','platformDivide'];
    // 屏蔽校验组件
    static notValidateItem = ['uploadIcon', 'uploadRecord', 'text', 'dangerDisposer', 'attachment', 'confirmBox'];
    // 过滤表单名称
    static filterFormLabelName = ['dangerDisposer','confirmBox'];

    constructor(props) {
        super(props)

        this.state = {
            validateStatus: undefined,
            help: "",
        };

        this.childRef = React.createRef();
    }

    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };
    }

    componentDidMount() {
        if (this.props.setValidatedStatus) {
            this.changeSetValidatedStatus();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // 点击取消修改的时候回退数据
        // 每个组件的value字段必须是value
        if (this.childRef?.current?.state.value !== this.props.fieldProps.value && !this.props.fieldProps.isUpdateInfo) {
            this.flushChildValue()
            this.changeSetValidatedStatus();
            this.setFiledValidateStatus("success");//恢复状态
        }
    }


    static getDerivedStateFromProps(props, state) {
        if (state !== props) {
            let newProps = {};
            for (const propsKey in props) {
                if (!Object.hasOwnProperty.call(FormItem.defaultProps, propsKey)) {
                    newProps[propsKey] = props[propsKey];
                }
                if (FormItem.filterFormLabelName.indexOf(props.itemType) > -1) {
                    newProps.label = "";
                }
            }
            return {...newProps, options: props.options || {rules: {}}}
        }
        return state
    }

    renderChildComponent(componentType, formKey, fieldProps = {}) {
        const ChildComponent = require(`./child/${componentType}`).default;
        const fieldPropsTemp = {...fieldProps, extra: FormItem.customFunctions}
        if (typeof fieldProps.onChange === 'function') {
            fieldPropsTemp['onChange'] = (...arg) => this.valueChange(...arg);
        }
        return <ChildComponent ref={this.childRef} fieldProps={fieldPropsTemp} name={formKey} form={this.props.form}
                               setFiledValidateStatus={this.setFiledValidateStatus.bind(this)}/>
    }

    // 不限制Form.Item高度配置
    noLimitHeight = ["attachment", "confirmBox"];

    render() {
        const {options, itemType, formKey = "", fieldProps} = this.props;
        const {isUpdateInfo} = fieldProps;
        const {getFieldDecorator} = this.props.form;
        const temp = {};
        if (!getFieldDecorator) {
            temp["htmlFor"] = formKey;
        }
        const fieldDecorator = getFieldDecorator && getFieldDecorator(formKey, this.formatOptionsRules(options));
        // 判断getFieldDecorator是否存在
        const renderChildComponent = getFieldDecorator ? fieldDecorator(this.renderChildComponent(itemType, formKey, this.props?.fieldProps)) : this.renderChildComponent(itemType, formKey, this.props?.fieldProps);
        let dataName = formKey;
        if (this.props?.fieldProps?.firstIndex || this.props?.fieldProps?.firstIndex === 0) {
            dataName = `${formKey}${this.props?.fieldProps?.firstIndex}`
        }
        return (
            <>
                {isUpdateInfo ?
                    <Form.Item
                        className={this.noLimitHeight.includes(itemType) ? "position-manage-form-item-noLimit" : "position-manage-form-item"} {...{...this.state, ...temp}}
                        validateStatus={this.state.validateStatus} help={this.state.help} data-name={dataName}>
                        {renderChildComponent}
                    </Form.Item>
                    : this.renderDetail(itemType, temp, dataName, formKey)}
            </>
        )
    }

    renderDetail = (itemType, temp, dataName, formKey) => {
        const {label, fieldProps} = this.props;
        const fieldPropsTemp = {...fieldProps, extra: FormItem.customFunctions}
        let Component = null;
        if (!itemType || (typeof itemType !== "string")) return console.log("字段不合法");
        try {
            Component = require(`../detail/item/${itemType}`).default;
        } catch (e) {
            try {
                Component = require('../detail/item/default').default;
            } catch (defaultError) {
                console.error('Default component also not found:', defaultError);
                return null;
            }
        }
        if (Component) {
            return (
                <div
                    className={"position-manage-detail"}
                    style={{padding: this.noPadding.includes(itemType) ? 0 : "", flexWrap: this.noPadding.includes(itemType) ? "wrap" : "nowrap"}}
                    data-name={dataName}>
                    {label && FormItem.filterFormLabelName.indexOf(itemType) === -1 ?
                        <div className={"position-manage-detail-label"} title={fieldProps?.labelName}
                             style={{textAlign: "left", flexShrink: 0, maxWidth: fieldPropsTemp.col === 12 ? 150 : 250}}>{label}：</div> : null}
                    <Component name={formKey} ref={this.childRef} {...fieldPropsTemp} fieldProps={fieldPropsTemp}/>
                </div>
            )
        }
    }

    noPadding = ["dangerDisposer"]

    /**
     *  刷新组件值
     * @param {*可选} componentType 组件类型
     * @param {*可选} refreshData 刷新数据集合
     */
    flushChildValue(componentType, refreshData) {
        const {itemType} = this.props;
        if (typeof this.childRef?.current?.updateValue === 'function') {
            if (componentType && componentType === itemType) {
                isRefreshSpecifyValue(refreshData, (data) => {
                    this.childRef.current.updateValue(data);
                })
            } else {
                isRefreshSpecifyValue(refreshData, (data) => {
                    this.childRef.current.updateValue(data);
                })
            }
        }

        function isRefreshSpecifyValue(refreshData, callBack) {
            if (Array.isArray(refreshData)) {
                callBack && callBack(refreshData);
            } else {
                callBack && callBack()
            }
        }
    }

    changeSetValidatedStatus() {
        const {itemType, fieldProps} = this.props;
        if (!FormItem.notValidateItem.includes(itemType) && fieldProps.value) {
            this.setState({
                validateStatus: "success",
            })
        } else {
            this.setState({
                validateStatus: undefined,
            })
        }
    }

    // 自定义修改修改表单校验状态方法
    setFiledValidateStatus(status = undefined, message = '') {
        const {itemType} = this.props;
        if (FormItem.notValidateItem.includes(itemType)) {
            this.setState({
                validateStatus: undefined,
            })
        } else {
            this.setState({
                validateStatus: status,
                help: message
            })
        }
    }

    valueChange(...arg) {
        if (typeof this.props.fieldProps.onChange === "function") {
            this.props.fieldProps.onChange(...arg);
        }
        try {
            if (!FormItem.notValidateItem.includes(this.props.itemType)) {
                this.validateFiled(this.formatOptionsRules(this.state.options || {}), arg[0])
            }
        } catch (error) {
            console.warn(error.message);
        }
    }

    // 表单项校验
    validateFiled(options, value) {
        const validated = {validateStatus: undefined, help: ""}
        options.rules.forEach(item => {
            if (Object.keys(item).includes("required")) {
                if (!value) {
                    validated['validateStatus'] = 'error';
                    validated['help'] = item.message;
                    this.setState({
                        ...validated
                    })
                    throw new Error(item.message);
                } else {
                    validated['validateStatus'] = "success"
                }
            } else if (Object.keys(item).includes("pattern")) {
                if (item.pattern && !new RegExp(item.pattern).test(value)) {
                    validated['validateStatus'] = 'error';
                    validated['help'] = item.message;
                    this.setState({
                        ...validated
                    })
                    throw new Error(item.message);
                } else {
                    validated['validateStatus'] = "success"
                }
            } else if (Object.keys(item).includes("max")) {
                if (!Number.isNaN(Number(item.max)) && value.length > item.max) {
                    validated['validateStatus'] = 'error';
                    validated['help'] = item.message;
                    this.setState({
                        ...validated
                    })
                    throw new Error(item.message);
                } else {
                    validated['validateStatus'] = "success"
                }
            } else if (Object.keys(item).includes("min")) {
                if (!Number.isNaN(Number(item.min)) && value.length < item.min) {
                    validated['validateStatus'] = 'error';
                    validated['help'] = item.message;
                    this.setState({
                        ...validated
                    })
                    throw new Error(item.message);
                } else {
                    validated['validateStatus'] = "success"
                }
            } else if (Object.keys(item).includes("len")) {
                if (!Number.isNaN(Number(item.len)) && value.length !== item.len) {
                    validated['validateStatus'] = 'error';
                    validated['help'] = item.message;
                    this.setState({
                        ...validated
                    })
                    throw new Error(item.message);
                } else {
                    validated['validateStatus'] = "success"
                }
            }
        })
        this.setState({
            ...validated
        })
    }

    // 格式化options中的rules
    formatOptionsRules(options) {
        const {required} = this.props;
        const optionsTemp = {...options}
        const rules = [];
        if (options.rules && typeof options.rules === 'object' && !Array.isArray(options.rules)) {
            if (!!required) {
                rules[0] = ({
                    required: !!required,
                    message: options.rules?.message && options.rules?.message !== '' ? options.rules?.message : this.props?.fieldProps?.placeholder,
                })
            }
            const rulesKeys = Object.keys(options.rules).filter(item => item !== "message");
            const newRules = rulesKeys.map(item => {
                const temp = {
                    message: options.rules?.message,
                };
                temp[item] = options.rules[item];
                return temp
            })
            optionsTemp.rules = Array.from(new Set([...rules, ...newRules]));
            return optionsTemp;
        } else if (Array.isArray(options.rules)) {
            if (!!required) {
                if (!!!optionsTemp.rules?.find(item => Object.keys(item).includes("required"))) {
                    // 获取对应字段的placeholder
                    optionsTemp.rules.unshift({
                        required: !!required,
                        message: this.props?.fieldProps?.placeholder,
                    })
                }
            }
            optionsTemp.rules = Array.from(new Set(optionsTemp.rules));
            return optionsTemp;
        } else if (!options.rules) {
            const rulesTemp = [];
            if (!!required) {
                // 获取对应字段的placeholder
                rulesTemp.unshift({
                    required: !!required,
                    message: this.props?.fieldProps?.placeholder,
                })
            }
            const newRulesTemp = Array.from(new Set(rulesTemp));
            return {...optionsTemp, rules: newRulesTemp}
        }
    }

}

export default FormItem;
